// extracted by mini-css-extract-plugin
module.exports = {"PixForm":"PixForm_PixForm__8zogZ","container":"PixForm_container__1HlYb","addressContainer":"PixForm_addressContainer__wF-wy","paper":"PixForm_paper__2-AvB"};